import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { injectDispatch } from '@ngrx/signals/events';
import {
  InputLabelComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import {
  offshoreConsumptionsFormEvents,
  offshoreConsumptionsEvents,
  OffshoreConsumptionsFormStore,
  AbstractStoreConnectedSectionComponent,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-total-consumptions',
  templateUrl: './total-consumptions.component.html',
  styleUrl: './total-consumptions.component.css',
  imports: [FormsModule, InputLabelComponent, NumberInputComponent],
})
export class TotalConsumptionsComponent extends AbstractStoreConnectedSectionComponent {
  object = Object;
  tabId = 'consumptions';
  sectionId = 'totalConsumptions';
  events = injectDispatch(offshoreConsumptionsFormEvents);
  extraEvents = injectDispatch(offshoreConsumptionsEvents);
  consumptionsStore = inject(OffshoreConsumptionsFormStore);

  readonly rows: { key: string; label: string; required?: boolean }[] = [
    { key: 'mainEngine', label: 'Main Engine (Total) (MT)', required: true },
    { key: 'auxEngines', label: 'Other Engines (Total) (MT)' },
    { key: 'boiler', label: 'Boiler (Total) (MT)' },
    { key: 'incinerator', label: 'Incinerator (Total) (MT)' },
    { key: 'total', label: 'Total' },
  ] as const;

  isRowRequired(rowKey: string, isRequired?: boolean): boolean {
    if (!isRequired) return false;
    return this.consumptionsStore.vm().isTotalConsumptionRowRequired(rowKey);
  }
}
